import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "src/environments/environment";
import { ToastType } from "../enums/toast-type";
import { IPaginatedResponse } from "../models/api/paginated-response";
import { IPaginationSearchParams } from "../models/api/pagination-search-params";
import { IDeleteNotificationSearchParams } from "../models/notification/delete-notification-search-params";
import { INotification } from "../models/notification/notification";
import { IUpdateNotificationPayload } from "../models/notification/update-notification-payload";

@Injectable({ providedIn: "root" })
export class NotificationService {
  isNotificationBarVisible = false;
  message = "";
  notificationType = ToastType.Info;

  callNotificationBar(message: string, notificationType: ToastType) {
    this.isNotificationBarVisible = true;
    this.message = message;
    this.notificationType = notificationType;

    setTimeout(() => {
      this.isNotificationBarVisible = false;
      this.message = "";
    }, 5000);
  }

  closeNotificationBar() {
    this.isNotificationBarVisible = false;
  }

  // New methods after refactoring 25.02.2026

  constructor(private readonly _httpClient: HttpClient) {}

  create(payload: INotification) {
    return this._httpClient.post<void>(this.withBaseUrl(), payload);
  }

  getAll(params: IPaginationSearchParams) {
    return this._httpClient.get<IPaginatedResponse<INotification>>(this.withBaseUrl("/all"), { params });
  }

  update(payload: IUpdateNotificationPayload) {
    return this._httpClient.put<void>(this.withBaseUrl(), payload);
  }

  delete(params: IDeleteNotificationSearchParams) {
    return this._httpClient.delete<void>(this.withBaseUrl(), { params });
  }

  private withBaseUrl(endpoint = "") {
    return `${environment.serverUrl}/notification${endpoint}`;
  }
}
